// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { FetchModelResponse, IFetchModel } from '@cian/http-api';
import type { IGetRecommendationsMicrofrontendV3Response } from '../../entities/GetRecommendationsMicrofrontendV3Response';
import type { IMicrofrontendHandlerErrorResponse } from '../../entities/MicrofrontendHandlerErrorResponse';

export interface IGetRecommendationsMicroFrontendRequest {
  /** Id региона пользователя **/
  regionId: number;
  /** Тип лэндинга **/
  landingType: EQueryParameters;
  /** Опция скрытия заголовка **/
  showHeader?: number;
  /** Опция показа полной версии рекомендаций **/
  showFullList?: number;
}

export enum EQueryParameters {
  /** Снять — квартиру на долгий срок **/
  'FlatRent' = 'flatRent',
  /** Посуточно — снять квартиру посуточно **/
  'FlatRentForDay' = 'flatRentForDay',
  /** Купить — квартиру во вторичке **/
  'SecondaryFlatSale' = 'secondaryFlatSale',
  /** Загородка — купить дом, дачу, таунхаус, участок **/
  'SuburbanSale' = 'suburbanSale',
  /** Главная cian.ru **/
  'MainPage' = 'mainPage',
}
export type IGetRecommendationsMicroFrontendResponse200 = FetchModelResponse<
  200,
  'json',
  IGetRecommendationsMicrofrontendV3Response
>;

export type IGetRecommendationsMicroFrontendResponse400 = FetchModelResponse<
  400,
  'json',
  IMicrofrontendHandlerErrorResponse
>;

export type TGetRecommendationsMicroFrontendResponse =
  | IGetRecommendationsMicroFrontendResponse200
  | IGetRecommendationsMicroFrontendResponse400;

export type TGetRecommendationsMicroFrontendModel = IFetchModel<
  IGetRecommendationsMicroFrontendRequest,
  undefined,
  TGetRecommendationsMicroFrontendResponse
>;

export interface IMappers<TResponse200, TResponse400> {
  200(response: IGetRecommendationsMicrofrontendV3Response, headers: Headers): TResponse200;
  400(response: IMicrofrontendHandlerErrorResponse, headers: Headers): TResponse400;
}
